import { FC, memo, Suspense, useMemo } from 'react';
import { Route, RouteProps } from 'react-router-dom';
import LayoutBeneficiary from '../../layouts/LayoutBeneficiary';
import PrivateRoute from '../../router/AdminRoute';
import { Loading } from '../Loading';

type AccessType = 'private' | 'public' | 'authentication';

export interface ProtectedLazyRouteProps extends RouteProps {
  noAccessRedirection?: string;
  isProtected?: boolean;
  isRootOnly?: boolean;
  fallbackComponent?: FC;
  access?: AccessType;
  withIAChat?: boolean;
}

const defaultFallback = <Loading />;

const ProtectedLazyRoute: FC<ProtectedLazyRouteProps> = memo(props => {
  const { component: Component, path, withIAChat = false, ...restProps } = props;
  const FallbackComponent = defaultFallback;

  const tags: any = document.getElementsByTagName('meta');
  const titleSignup = 'E-Orientaction – La 1ere plate-forme de tests en ligne française';
  const titleOA = 'E-ORIENTACTION';
  document.title = path === '/' || path === '/signup' ? titleSignup : titleOA;
  tags.description.content = path === '/' || path === '/signup' ? titleSignup : titleOA;

  const WrappedComponent = useMemo(() => {
    if (!withIAChat || !Component) {
      return Component;
    }

    const ComponentWithLayout = (componentProps: any) => (
      <LayoutBeneficiary>
        <Component {...componentProps} />
      </LayoutBeneficiary>
    );

    ComponentWithLayout.displayName = `WithIAChat(${
      Component.displayName || Component.name || 'Component'
    })`;

    return ComponentWithLayout;
  }, [Component, withIAChat]);

  return (
    <Suspense fallback={FallbackComponent}>
      <PrivateRoute {...restProps} path={path} component={WrappedComponent as any} />
    </Suspense>
  );
});

export default ProtectedLazyRoute;
